import React from 'react'
import styles from './Home.module.scss';
import Comisiones from '../../assets/img-comisiones.png'
import Seguridad from '../../assets/img-seguridad.png'
import Slider from '../../assets/img-slider.png'
import { ButtonGradient, Title } from '../../components';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';

export const Home = () => {
    const { isMobile } = useSelector((state: RootState) => state.data);

    return (
        <>
            <div className={styles.firstSection}>
                <div className={styles.leftMiddle}>
                    <p className={`${styles.title} title-montserrat text-black`}>Revoluciona el control de tus finanzas empresariales</p>
                    <p className={`${styles.subtitle} text-inter text-black`}>Nuestra solución empresarial te permite gestionar de forma eficiente y centralizada tus pagos a proveedores y colaboradores</p>

                    <ButtonGradient label="Empieza ahora" initialGradient />
                    {isMobile && <img className={styles.imgSlider} src={Slider} alt='slider' />}
                </div>
            </div>
            <div className={styles.secondSection}>
                <div className={styles.left}>
                    {isMobile ?
                        <p className='title-montserrat text-black'>Miles de pagos en un solo clic</p>
                        :
                        <>
                            <p className='title-montserrat text-black'>Miles de pagos en</p>
                            <p className='title-montserrat text-black'>un solo clic</p>
                        </>
                    }

                </div>
                <div className={styles.container}>
                    <img alt='comissions' src={Comisiones} />
                    <div className={styles.conntentCard}>
                        <div className={styles.card}>
                            <div className={styles.borderBottom}></div>
                            <Title title="Olvídate de las comisiones ocultas" />
                            <p className='subtext-inter text-black'>
                                Nuestra plataforma <span className='text-bold'>LivingRock</span> te permite realizar
                                pagos de forma transparente y segura, optimizando
                                la experiencia de cobro para tu negocio y clientes.
                            </p>
                            <p className='subtext-inter text-black'>Monitorea en tiempo real tus movimientos</p>
                            <div className={styles.borderLeft}></div>
                        </div>
                    </div>

                </div>
            </div>
            <div className={styles.thirdSection}>
                <img alt='security' src={Seguridad} />
                <div className={styles.contentThird}>
                    <Title title="La seguridad es prioridad" color="white" aling="center" />
                    <p className={`${styles.desc} text-inter text-white`}>
                        Implementamos los más altos estándares internacionales en protección de datos y transacciones, utilizando
                        tecnologías avanzadas de encriptación, monitoreo continuo y autenticación robusta.
                    </p>
                </div>
            </div>
        </>
    )
}
